/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { O5AwsDeployerV1DeploymentEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const O5_AWS_DEPLOYER_V1_DEPLOYMENT_EVENT_ENTITY_NAME = 'o5.aws.deployer.v1.DeploymentEvent';
export const o5AwsDeployerV1DeploymentEventEntity = new schema.Entity<O5AwsDeployerV1DeploymentEvent>(O5_AWS_DEPLOYER_V1_DEPLOYMENT_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: O5AwsDeployerV1DeploymentEvent) => `${entity.metadata?.eventId}` });

